<template>
    <div class="admin-auth-page">
        <div class="admin-auth-form">
            <h2>Admin Panel - Авторизация</h2>
            <form class="login-form-in" @submit.prevent="initLogin">
                <div class="form-group">
                    <input type="login" name="login" v-model="user.email" placeholder="E-mail" class="form-control" v-validate="{ required: true, regex: regexRules.mail }" data-vv-delay="1000">
                    <span class="error-message" v-show="errors.has('login')" :class="{visible: errors.has('login')}">Введите ваш email</span>
                </div>
                <div class="form-group">
                    <input :type="passwordFieldType" name="password" v-model="user.password" placeholder="Пароль" class="form-control" v-validate="{ required: true}" data-vv-delay="1000">
                    <span class="error-message" v-show="errors.has('password')" :class="{visible: errors.has('password')}">Введите ваш пароль</span>
                </div>
                <div class="form-btn">
                    <button class="btn-login" @click.prevent="initLogin" :disabled="errors.any()">
                        <span>Войти</span>
                    </button>
                </div>
                <span class="error-msg" v-if="errorAuth">Вы ввели неверный E-mail или пароль</span>
            </form>
        </div>
    </div>
</template>

<script>
    // import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue'
    import { signInWithEmailAndPassword } from "firebase/auth";
    export default {
        name: 'admin--auth',
        components: {
            // svgIcon,
        },
        data () {
            return {
                errorCredits: false,
                errorAuth: false,
                openPas: false,
                passwordFieldType: 'password',
                regexRules: {
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/,
                },
                user: {
                    email: '',
                    password: '',
                },
            }
        },
        methods: {
            initLogin() {
                // console.log(this.user);
                this.$validator.validate().then(result => {
                    if(result) {
                        console.log(true, 'authform')
                        signInWithEmailAndPassword(this.$auth, this.user.email, this.user.password)
                        .then((userCredential) => {
                            this.errorAuth = false;
                            this.$store.dispatch('getAdminData', userCredential.user.uid);
                            setTimeout(() => {
                                this.$router.push('/admin');
                            }, 600);
                        })
                        .catch((error) => {
                            const errorCode = error.code;
                            const errorMessage = error.message;
                            if (errorCode == 'auth/invalid-credential') {
                                this.errorAuth = true;
                            }
                            console.log(errorCode);
                        });
                    } else {
                        console.log('Form login with errors');
                    }
                });
            },
        },
        beforeRouteEnter (to, from, next) {
            const adminLocalState = localStorage.getItem('adminArrData');
            if (adminLocalState == null) {
                next()
            } else {
                next('/admin');
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'admin-auth';
        },
        created () {
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/admin/admin-auth.scss';
</style>